import { openLoginModal } from 'store/slice/accountModalSlice';
import { useStoreDispatch, useStoreSelector } from 'store/hooks/storeHooks';
import { useWantedProduct } from 'wants/hooks/useWantedProduct';
import { WantButton } from 'wants/components/WantButton';

export interface IWantProductButtonProps {
  'data-qa'?: string;
  className?: string;
  productId: string | number;
}

export const WantProductButton = ({ productId, ...rest }: IWantProductButtonProps) => {
  const { isAuthenticated } = useStoreSelector((state) => state.auth);
  const { isLoading, wanted, toggleWant, error } = useWantedProduct(productId);
  const storeDispatch = useStoreDispatch();

  const onClick = async () => {
    if (!isAuthenticated) {
      storeDispatch(openLoginModal());
    } else {
      await toggleWant();
    }
  };

  return <WantButton wanted={wanted} onClick={onClick} loading={error || isLoading} {...rest} />;
};
